import React from 'react'


function Ads() {
    const downloadImgStyle = 'border-[2px] border-white rounded-[13px] h-[3rem] w-[10rem]'
    return (
     
    <div className="download">
        <div className="download_images flex ">
          <a href="https://educacionlaboral.com.do" >
          <img
          
          src={require("../img/educacion-laboral-logo.png")}
          alt=""
          className={downloadImgStyle + ` mr-[2rem] cursor-pointer`}
        />
          </a>
     

        </div>



    </div>
    
    


    
    )
    
}

export default Ads